import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export const nameValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  const name = control.value?.trim();
  const nameRegex = /^[A-Za-zÀ-ſ\s]+$/;
  if (name) {
    const nameParts = name.split(" ");
    return nameParts.length >= 2 && nameRegex.test(name)
      ? null
      : { invalidName: true };
  }
  return null;
};
